import { Button, ButtonProps } from '@heroui/react';
import React, { FC } from 'react';

export interface ButtonConfig extends ButtonProps {
  label?: string;
}

interface NavButtonProps extends ButtonConfig {
  direction: 'previous' | 'next';
}

const getDefaultLabel = (direction: 'previous' | 'next'): string => (
  direction === 'previous' ? 'Previous' : 'Save + Next'
);

export const NavButton: FC<NavButtonProps> = ({
  label,
  direction,
  ...buttonAttributes
}) => {
  const buttonText = label ?? getDefaultLabel(direction);

  return (
    <Button
      {...buttonAttributes}
      size="sm"
    >
      {buttonText}
    </Button>
  );
};
